// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Section_wrapper__hndDA","header":"Section_header__GZUJx"};